import { useEffect, useState } from 'react'
import { typedDoc, onSnapshot } from '@/lib/firebase/firestore'
import type { ImageSlotDocument } from '@/types'
import type { SlotKey } from '../slotRegistry'

export function useImageSlot(slotKey: SlotKey) {
  const [assignment, setAssignment] = useState<ImageSlotDocument | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const ref = typedDoc<ImageSlotDocument>('imageSlots', slotKey)
    return onSnapshot(ref, (snap) => {
      setAssignment(snap.exists() ? (snap.data() as ImageSlotDocument) : null)
      setLoading(false)
    })
  }, [slotKey])

  return { assignment, loading }
}
